<template>
    <div :class="`w-full shadow bg-indigo-100 dark:bg-gray-600 rounded p-3 my-2 grid ${gridColsClass} gap-2 items-start`">
        <div
            v-for="(cell, index) in value.cells"
            :key="`table-cell-${cell.key || cell.id}`"
            class="col-span-1"
        >
            <table-cell
                v-model="value.cells[index]"
                :language="language"
                :type-id="typeId"
                :document-type="documentType"
                :disabled="disabled"
                @reference-label-changed="(label) => $emit('reference-label-changed', {label, td: index})"
                @cell-type-changed="(typeId) => $emit('cell-type-changed', {typeId, td: index})"
                :error="error?.cellsArray && error.cellsArray[index] ? error.cellsArray[index] : null"
            />
        </div>
    </div>
</template>

<script>
import siteLanguage from '../../config/siteLanguage'
import RocketLink from "../Link/RocketLink.vue";
import InputText from "../form/InputText.vue";

export default {
    name: "TableRow",
    components: {InputText, RocketLink},
    props: {
        value: {
            required: true,
            type: Object,
        },
        language: {
            type: Object,
            default: () => {
                return {
                    iso: siteLanguage.iso.ENGLISH,
                    id: siteLanguage.language.ENGLISH,
                };
            },
        },
        typeId: {
            type: Number,
            required: true,
        },
        documentType: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: Object,
            required: false,
        },
    },
    computed: {
        gridColsClass () {
            // need to do it like this so tailwind detects the classes
            // otherwise they won't be included in the css
            switch (this.value.cells.length) {
                case 1: return 'grid-cols-1';
                case 2: return 'grid-cols-2';
                case 3: return 'grid-cols-3';
                case 4: return 'grid-cols-4';
                case 5: return 'grid-cols-5';
                case 6: return 'grid-cols-6';
                default: return '';
            }
        },
    },
}
</script>
